import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

export default function FeaturedComics() {
  const featured = comics.filter((c) => c.featured);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              推荐作品
            </h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选，品质之选</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap font-medium"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}